module.exports = __webpack_public_path__ + "810743829b09a55943d05dbae29852b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/24.jpg
// module id = 1351
// module chunks = 47